import { Component, Input, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ReplaySubject, Subscription, takeUntil } from 'rxjs';
import { TeamUserResponse } from '../../../../home/administration/manage-users/models/manage-users.model';
import { ManageUsersService } from '../../../../home/administration/manage-users/services/manage-users.service';
import { GlobalFilterSharedService } from '../../../../shared/services/global-filter-shared.service';
import { GlobalFilterService } from '../../../../shared/services/global-filter.service';
import { FilteredUserTeamData } from '../../../models/common-data.model';
import { SelectionModel } from '@angular/cdk/collections';
import { HelpersService } from '../../../services/helpers.service';

@Component({
  selector: 'app-team-users-add',
  templateUrl: './team-users-add.component.html',
  styleUrls: ['./team-users-add.component.scss'],
})
export class TeamUsersAddComponent {
  modalRef: BsModalRef;
  teamId: string;
  @Input() selectedTeamName;
  dataSubject: Subscription;
  isLoading: boolean = false;
  isUsersExists: boolean = true;
  teamUsers: TeamUserResponse[] = [];
  dataSource = new MatTableDataSource<any>([]);
  @ViewChild('template', { static: true }) template: any;
  destroy: ReplaySubject<any> = new ReplaySubject<any>(1);
  displayedColumns: string[] = ['Checkbox', 'UserName', 'Email'];
  selection = new SelectionModel<TeamUserResponse>(true, []);

  constructor(
    private modalService: BsModalService,
    private helpersService: HelpersService,
    private manageUsersService: ManageUsersService,
    private globalFilterService: GlobalFilterService,
    private globalFilterSharedService: GlobalFilterSharedService
  ) {
    this.dataSubject = globalFilterSharedService
      .getSubjectTeamUsersAddModal()
      .pipe(takeUntil(this.destroy))
      .subscribe((id: string) => {
        if (id) {
          this.teamId = id;
          this.isUsersExists = true;
          this.selection.clear();
          this.dataSource = new MatTableDataSource<any>([]);

          this.showModal();
          this.getUsersByTeamId(id);
        }
      });
  }

  private showModal() {
    this.modalRef = this.modalService.show(this.template, {
      class: 'modal-dialog-centered modal-lg',
    });
  }

  getUsersByTeamId(teamId: string) {
    this.isLoading = true;
    this.manageUsersService.getUsersByTeamId(teamId).subscribe(
      (teamUsers: TeamUserResponse[]) => {
        this.teamUsers = teamUsers;
        var selectedUserIds = this.helpersService.getSelectedTeamUserIds();
        this.isUsersExists = teamUsers.length > 0;
        this.dataSource = new MatTableDataSource<TeamUserResponse>(teamUsers);

        this.selection.select(
          ...this.dataSource.data?.filter((item) =>
            selectedUserIds?.includes(item.userId)
          )
        );

        this.isLoading = false;
      },
      () => {
        this.isLoading = false;
      }
    );
  }

  onCheckboxChange(event: any, userId: string) {
    let selectedUser = this.teamUsers.find((user) => user.userId == userId);
    if (selectedUser) {
      selectedUser.isChecked = event.checked;
    }
  }

  onClickUserSelect() {
    var selectedTeamUsers =
      this.globalFilterService.getSelectedTeamUser() ?? [];

    var teamUsersWithoutCurrentTeam = selectedTeamUsers?.filter(
      (item) => item.teamId !== this.teamId
    );

    var selectedUserIds = this.selection.selected?.map((item) => item.userId);

    if (selectedUserIds.length > 0) {
      var filtedUserTeamData: FilteredUserTeamData = {
        teamId: this.teamId,
        userIds: selectedUserIds,
      };

      teamUsersWithoutCurrentTeam.push(filtedUserTeamData);
    }

    this.globalFilterService.setSelectedTeamUser(teamUsersWithoutCurrentTeam);

    this.globalFilterSharedService.setSubjectApplyGlobalFilter(true);

    this.modalRef?.hide();
  }

  handleCancel() {
    this.modalRef?.hide();
    this.globalFilterSharedService.setSubjectTeamUsersAddModal('');
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.data);
  }

  ngOnDestroy() {
    this.modalRef?.hide();
    this.destroy.next(null);
    this.globalFilterSharedService.setSubjectTeamUsersAddModal('');
  }
}
